/* RSI v2 · Reiseguide – logikk fra Claude Design. Krever rsi-dc.js. */

class RSIP_reiseguide extends DCLogic {
  renderVals() {
    
    return {};
  }
}

window.RSIP_reiseguide = RSIP_reiseguide;
